import { Link } from 'react-router-dom';
import { footerLinks } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-18">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          {footerLinks.columns.map((column) => (
            <div key={column.title}>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                {column.title}
              </h4>
              <div className="w-8 h-px bg-accent-500/40 mb-4"></div>
              <ul className="space-y-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-300 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 md:mt-18 pt-8 border-t border-foreground-800/30">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex flex-col">
              <div className="flex items-baseline gap-2">
                <span className="font-heading text-3xl md:text-4xl font-black text-accent-500">
                  51
                </span>
                <span className="font-heading text-3xl md:text-4xl font-black text-background-50">
                  吃瓜网
                </span>
              </div>
              <p className="text-xs text-foreground-400 mt-1">{footerLinks.brandSubtitle}</p>
            </div>

            <div className="flex flex-col items-start sm:items-end gap-2">
              <p className="text-xs text-foreground-400">{footerLinks.copyright}</p>
              <div className="flex items-center gap-4">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800/40 hover:bg-accent-500/80 transition-colors duration-200 cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800/40 hover:bg-accent-500/80 transition-colors duration-200 cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800/40 hover:bg-accent-500/80 transition-colors duration-200 cursor-pointer" aria-label="哔哩哔哩">
                  <i className="ri-bilibili-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800/40 hover:bg-accent-500/80 transition-colors duration-200 cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}